<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 mb-4 px-2 text-center">
      <h2 class="mb-2 text-center">Verify Code</h2>
      You should receive a 6-digit code.  Enter it below along with your new password.
    </div>
    <v-form ref="form" @submit.prevent="verifyClick">
      <v-otp-input 
        length="6" class="mb-4"
        type="number"
        v-model="code"
        :rules="[required, valid_code]"
        tabindex="1"
      />

      <v-text-field
        v-model="password"
        :type="pw_visible ? 'text' : 'password'"
        outlined dense
        label="Password"
        :rules="[required, valid_password]"
        validate-on-blur
        tabindex="2"
        placeholder=" " persistent-placeholder
        autocomplete="new-password" autocapitalize="none"
        :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="pw_visible = !pw_visible"
      />
      <v-text-field
        v-model="confirmation"
        :type="pw_visible ? 'text' : 'password'"
        outlined dense
        label="Confirm Password"
        :rules="[required, matches_password]"
        validate-on-blur
        tabindex="3"
        placeholder=" " persistent-placeholder
        autocomplete="new-confirm" autocapitalize="none"
        :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append="pw_visible = !pw_visible"
      />
      <div class="ml-3 mt-n1 mb-5">
        Didn't receive your code?
        <router-link :to="{ name: 'forgot' }" replace>
          Request again.
        </router-link>
      </div>
      <div class="d-flex justify-center">
        <v-btn width="60%" type="submit" color="primary">Update Password</v-btn>
      </div>
    </v-form>
    <ErrorOverlay
      title="Verfication Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </div>
</template>

<script>
import { ErrorOverlay } from '@/components/pages'

import { mapActions, mapGetters, mapMutations } from 'vuex'
import { required, valid_code, valid_password, matches } from '@/lib/validations'

export default {
  name: 'Verify',

  components: { ErrorOverlay },

  data: () => ({
    code: '',
    password: '',
    confirmation: '',
    pw_visible: false,

    // validation rules
    required,
    valid_code,
    valid_password,

    // error handling
    loading: false,
    error_dialog: false,
    error_message: false,
  }),

  computed: {
    ...mapGetters('auth', { contact: 'unverifiedPro' }),

    // validation rules requiring access to data
    matches_password() { return matches(this.password, 'Password') }
  },

  methods: {
    ...mapActions('auth', ['resetPassword']),
    ...mapMutations('auth', { setAcceptanceKeys: 'SET_ACCEPTANCE_KEYS'}),

    async verifyClick() {
      if (this.$refs.form.validate()) {
        
        this.loading = true
        const result = await this.resetPassword({
          contact: this.contact,
          password_recovery_code: this.code,
          password: this.password,
        })
        this.loading = false

        if (result.ok) {
          this.$router.replace({ name: 'home' })
        } else if (result.status == 403) {
          this.setAcceptanceKeys(result)
          this.$router.push({ name: 'alerts/accept' })
        } else {
          this.error_message = 'That code did not match, please verify your claim code.'
          this.error_dialog = true
        }
      }
    },
  },
}
</script>
